import { Sparkles } from "lucide-react";
import { Badge } from "@client/components/ui/Badge";
import { catalogCopy } from "@client/locales/id/catalog";

/**
 * Sits over a product image (the parent must be `relative`): the dark glass backing keeps the
 * pill legible on any cover.
 */
export function RecommendedBadge() {
  return (
    <span className="absolute top-3 left-3 rounded-full bg-background-deep/70 backdrop-blur-md">
      <Badge>
        <Sparkles className="size-3.5 text-accent-bright" aria-hidden="true" />
        {catalogCopy.featuredBadge}
      </Badge>
    </span>
  );
}
